import React, { ComponentProps } from 'react'

type CheckMarkIconProps = ComponentProps<'svg'> & {
    iconColor?: string
}

export const CheckMarkIcon = ({
    iconColor = '#fff',
    ...props
}: CheckMarkIconProps) => (
    <svg
        width="14"
        height="13"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1.375 7.29346L5.875 11.7935L12.625 1.66846"
            stroke={iconColor}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
)
